/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deletecontentreportwarning3Inputs */

const en_deletecontentreportwarning3 = /** @type {(inputs: Deletecontentreportwarning3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. The report will be permanently deleted.`)
};

const de_deletecontentreportwarning3 = /** @type {(inputs: Deletecontentreportwarning3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Aktion kann nicht rückgängig gemacht werden. Die Meldung wird dauerhaft gelöscht.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone. The report will be permanently deleted." |
*
* @param {Deletecontentreportwarning3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deletecontentreportwarning3 = /** @type {((inputs?: Deletecontentreportwarning3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletecontentreportwarning3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deletecontentreportwarning3(inputs)
	return de_deletecontentreportwarning3(inputs)
});
export { deletecontentreportwarning3 as "deleteContentReportWarning" }